module.exports = __webpack_public_path__ + "img/f2fimg.21f3e1f8.svg";